import { Truck, ShoppingBag, Landmark, Banknote, Stethoscope, Building2, GraduationCap, Factory, Car } from "lucide-react";

// Framing rule: describe what we BUILD for the sector — never claim we
// already have clients in it. Where real work exists (logistics, retail /
// e-commerce, automotive) we name the platform on the dedicated industry
// page, not here.
const INDUSTRIES = [
  { icon: Truck, name: "Logistics & transportation", outcome: "Dispatch, driver apps and live ETAs that customers can see." },
  { icon: ShoppingBag, name: "Retail & e-commerce", outcome: "One order across storefront, marketplace and physical stock." },
  { icon: Landmark, name: "Government & public sector", outcome: "Bilingual, auditable citizen portals and workflow systems." },
  { icon: Banknote, name: "Banking & financial services", outcome: "Digital onboarding, KYC and risk built around your regulated core." },
  { icon: Stethoscope, name: "Healthcare", outcome: "Patient systems designed for the PDPL sensitive-data rules." },
  { icon: Building2, name: "Real estate & facilities", outcome: "Property CRM, community apps and facilities workflows." },
  { icon: GraduationCap, name: "Education", outcome: "School management, LMS, admissions and parent apps." },
  { icon: Factory, name: "Manufacturing & distribution", outcome: "Production, quality, maintenance and dealer portals." },
  { icon: Car, name: "Automotive", outcome: "Showroom, service and parts joined around the vehicle." },
];

export function Industries() {
  return (
    <section data-testid="industries-section" className="bg-white">
      <div className="mx-auto max-w-7xl px-4 py-20 lg:px-6 lg:py-28">
        <div className="max-w-3xl">
          <div className="text-xs font-semibold uppercase tracking-widest text-wafa-primary">Industries</div>
          <h2 className="mt-3 font-heading text-3xl font-semibold tracking-tight text-wafa-deep sm:text-4xl lg:text-5xl">
            Industries we build for.
          </h2>
          <p className="mt-4 text-base text-wafa-ink/70 lg:text-lg">
            The sectors our platforms and products are designed around.
          </p>
        </div>

        <div className="mt-14 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {INDUSTRIES.map(({ icon: Icon, name, outcome }) => (
            <div
              key={name}
              data-testid={`industry-${name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="group flex items-start gap-4 rounded-lg border border-wafa-deep/10 bg-white p-5 transition-all duration-200 hover:-translate-y-1 hover:border-wafa-deep/25 hover:shadow-[0_16px_40px_-20px_rgba(14,79,58,0.25)]"
            >
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-wafa-cream/70 text-wafa-deep transition-colors group-hover:bg-wafa-primary group-hover:text-white">
                <Icon className="h-5 w-5" />
              </div>
              <div>
                <div className="font-heading font-semibold text-wafa-deep">{name}</div>
                <p className="mt-1 text-sm text-wafa-ink/75">{outcome}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
